cockpitApp.filter('documentTypeOf', function() {
  return function (documents, documentType) {
    documents = documents || [];
    return documents.filter(function (document) {
      return document.type == documentType;
    });
  }
});
